import { MAX_CONTENT_WIDTH } from "config/resolution";
import styled from "styled-components/macro";

export const Footer = styled.footer(({ theme: { color } }) => ({
  backgroundColor: color.brandPrimary.medium,
  zIndex: "1",
}));

export const FooterContentWrapper = styled.div(({ theme: { color } }) => ({
  display: "block",
  flexDirection: "column",
  padding: 0,
  left: 0,
  bottom: 0,
  width: "100%",
  color: color.neutral["08"],
}));

export const FooterContent = styled.div(({ theme: { spacing, breakpoint } }) => ({
  display: "flex",
  flexDirection: "column",
  padding: `0 16px ${spacing.stack.xl}`,
  background: "transparent",

  [breakpoint.lg()]: {
    margin: 0,
    padding: `0 36px ${spacing.stack.md}`,
  },

  [breakpoint.xl()]: {
    maxWidth: MAX_CONTENT_WIDTH,
    padding: "0 112px",
    margin: "auto",
  },
}));
